import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {JWT} from "../../constants/local-storage";
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {SYSTEM_ROLES} from "../../constants/general-constants";
import {SYSTEM_ROLE_SUPERADMIN} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import EditButtonPanel from '../administration/components/EditButtonPanel';
import AdminListPanelUserFacilityMatrix from '../administration/components/AdminListPanelUserFacilityMatrix';
import AdminListPanelUserHomePage from '../administration/components/AdminListPanelUserHomePage';
import AdminListPanelUserHomeResource from '../administration/components/AdminListPanelUserHomeResource';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import * as adminStyles from "./components/AdminStyles";

export default function AdministrationUsersEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityCode, setEntityCode] = useState("");
	const [entitySystemCode, setEntitySystemCode] = useState("");
	const [entityDescription, setEntityDescription] = useState("");
	const [entityName, setEntityName] = useState("");
	const [entityUsername, setEntityUsername] = useState("");
	const [entityEmail, setEntityEmail] = useState("");
	const [entityRole, setEntityRole] = useState("");
	
	const [roleOptions, setRoleOptions] = useState([]);
	
	const [userFacilityMatricies, setUserFacilityMatricies] = useState([]);
	const [userHomeResources, setUserHomeResources] = useState([]);
	const [userHomepages, setUserHomepages] = useState([]);
	
	
	const refCode = useRef(null);
	const refSystemCode = useRef(null);
	const refDescription = useRef(null);
	const refName = useRef(null);
	const refUsername = useRef(null);
	const refEmail = useRef(null);
	const refRole = useRef(null);
	
	const id = useParams()["id"];
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	useEffect(() => {
		let tempRoleOptions = [];
		for(let i=0; i<SYSTEM_ROLES.length; i++){
			if(SYSTEM_ROLES[i].id === SYSTEM_ROLE_SUPERADMIN){
				try{
					if(globalState.state.loggedIn.roles.includes(SYSTEM_ROLE_SUPERADMIN)){	
						tempRoleOptions.push({
							value:SYSTEM_ROLES[i].id,
							text:SYSTEM_ROLES[i].name
						});
					}
				}
				catch(e){}
			}
			else{
				tempRoleOptions.push({
					value:SYSTEM_ROLES[i].id,
					text:SYSTEM_ROLES[i].name
				});
			}
		}
		setRoleOptions(tempRoleOptions);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/administration/edit/user?id=" + id, null, initialiseFields);
	}, []);
	
	const initialiseFields = (entity) => {
		try{
			setEntityCode(entity.code);
			setEntitySystemCode(entity.systemCode);
			setEntityDescription(entity.description);
			setEntityName(entity.name);
			setEntityUsername(entity.username);
			setEntityEmail(entity.email);
			setEntityRole(entity.role);
			refCode.current.value = entity.code;
			refName.current.value = entity.name;
			refUsername.current.value = entity.username;
			refEmail.current.value = entity.email;
			refRole.current.value = entity.role;
		}
		catch(e){}
		
	};
	
	const mainComponentRows = [
		{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refUsername, id:"3", title:"Username", inputType:INPUT_TYPE_TEXT},
		{ref:refEmail, id:"4", title:"Email", inputType:INPUT_TYPE_TEXT},
		{ref:refRole, id:"5", title:"Role", inputType:INPUT_TYPE_SELECT, options:roleOptions},
		{ref:refSystemCode, id:"6", title:"System Code", inputType:INPUT_TYPE_TEXT},
		{ref:refDescription, id:"7", title:"Description", inputType:INPUT_TYPE_TEXT}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	
	const contentPanel = {
		display:"flex",
		width:"100%",
		flexWrap:"wrap"
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	const editButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		borderRadius:"4px",
		alignItems:"center",
		color:'blACK',
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:'pointer',
		border:"1px solid " +DEFAULT_BLUE,
		margin:"5px"
	};
	
	
	const popupBackground = {
	    position:"fixed",
	    top:"0px",
	    left:"0px",
	    width:"100%",
	    height:"100%",
	    background:"rgba(0,0,0,0.7)",
	    zIndex:"9999",
	    display:"flex",
	    justifyContent:"center",
	    alignItems:"center"
	};

	const popupPanel = {
	    width:"900px",
	    height:"700px",
	    background:"#111",
	    border:"1px solid " + DEFAULT_BLUE,
	    borderRadius:"8px",
	    padding:"20px",
	    display:"flex",
	    flexDirection:"column"
	};

	const popupTextarea = {
	    flex:"1",
	    width:"100%",
	    background:"#222",
	    color:"white",
	    border:"1px solid #444",
	    padding:"12px",
	    resize:"none",
	    overflow:"auto"
	};
	
	const getSubmitObject = () => {
		
		let submitObject = {
			id:id,
			code:refCode.current.value,
			name:refName.current.value,
			username:refUsername.current.value,
			email:refEmail.current.value,
			role:refRole.current.value,
			systemCode:refSystemCode.current.value,
			description:refDescription.current.value
		};
		return submitObject
	}
	
	const goSubmit = () => {
		
		let systemName = window.location.hostname;
		if(systemName === "localhost"){
			systemName = "localhost:3000";
		}
		functions.submitAjax("/resolutionsoftwareplatform/administration/submit/user", 
				getSubmitObject(), saveUserFacilityMatricies,  STRINGIFY, handleSubmitError);
		
	};
	
	const setUserFacilityMatriciesFromExternal = (inputUserFacilityMatricies) => {
		setUserFacilityMatricies(inputUserFacilityMatricies);
	};
	
	
	const saveUserFacilityMatricies = () => {
		
		functions.submitAjax("/resolution/userfacilitymatrixbulksave?userId=" + id, 
				userFacilityMatricies, null,  STRINGIFY, handleSubmitError);
		saveUserHomeResources();		
	};
	
	const saveUserHomeResources = () => {
		functions.submitAjax("/resolution/userhomeresourcebulksave?userId=" + id, 
				userHomeResources, null,  STRINGIFY, handleSubmitError);
		saveUserHomepages();		
	};
	
	const saveUserHomepages = () => {
		functions.submitAjax("/resolution/userhomepagebulksave?userId=" + id, 
				userHomepages, null,  STRINGIFY, handleSubmitError);
		saveEnd();		
	};
	
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolutionsoftwareplatform/administration/submit/delete/user", 
				id, saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};
	
	
	const goResetPassword = () => {

	    if(!window.confirm("Reset this user's password and email them directly?")){
	        return;
	    }

	    functions.submitAjax(
	        "/resolutionsoftwareplatform/administration/submit/resetpassword/user",
	        id,
	        handlePasswordResetSuccess,
	        STRINGIFY,
	        handleSubmitError
	    );
	};

	const handlePasswordResetSuccess = () => {

	    alert("Temporary password emailed successfully.");
	};

	const goGenerateResetEmail = () => {

	    if(!window.confirm("Reset this user's password and send a copy to yourself?")){
	        return;
	    }

	    functions.submitAjax(
	        "/resolutionsoftwareplatform/administration/submit/resetpasswordadmincopy/user",
	        id,
	        handleGenerateResetEmailSuccess,
	        STRINGIFY,
	        handleSubmitError
	    );
	};

	const handleGenerateResetEmailSuccess = () => {

	    alert("Password reset email sent to your email address.");
	};
	
	

	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={adminStyles.administrationHeader}>
					User Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<AdminListPanelUserFacilityMatrix
					userId={id}
					setFunction={setUserFacilityMatriciesFromExternal}
					currentUserFacilityMatricies={userFacilityMatricies}
					/>
					<AdminListPanelUserHomePage
					userId={id}
					setFunction={setUserHomepages}
					/>
					<AdminListPanelUserHomeResource
					userId={id}
					setFunction={setUserHomeResources}
					/>
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="users"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
				
				
				<div style={{
				       display:"flex",
				       marginRight:"20px",
					   position:'fixed',
					   right:'0px',
					   top:'70px'
				   }}>

				       <div
				           style={editButton}
				           onClick={goResetPassword}>
				           Reset Password
				       </div>

				       <div
				           style={editButton}
				           onClick={goGenerateResetEmail}>
				           Email Reset To Me
				       </div>

				   </div>
				   
				  
			</div>
			
		
	);
}